import { Typography } from '@mui/material';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getMainSetting } from 'src/shared/functions/getMainSetting';
import { CurrencyEnum } from 'src/shared/models/enums/currency.enum';
import { MainSettingsEnum } from 'src/shared/models/enums/mainSettings.enum';

type AmountWithCurrencyProps = {
  amount: number;
  decimals?: number;
  showCurrencyInSecondaryStyle?: boolean;
  currencyVariant?: 'h6' | 'h5' | 'body2' | 'body1' | 'caption';
  compact?: boolean;
  compactDecimals?: number;
};

export const AmountWithCurrency = (props: AmountWithCurrencyProps) => {
  const { amount, decimals = 2, showCurrencyInSecondaryStyle = false, currencyVariant = 'body2', compact = false, compactDecimals = 1 } = props;
  const { currentUser, currentMember } = useGlobals();
  const settingMainSettings = currentUser?.mainSettings ?? currentMember?.mainSettings;
  const currency = getMainSetting(settingMainSettings ?? [], MainSettingsEnum.Currency, CurrencyEnum.SEK);

  // Konvertera beloppet till en sträng med önskat antal decimaler
  const amountToFixed = amount == null || Number.isNaN(amount) ? '0' : Number(amount).toFixed(decimals);

  // Separera hela delen och decimaldelen (hantera negativa tal separat)
  const isNegative = amountToFixed.startsWith('-');
  const [integerPart, decimalPart] = (isNegative ? amountToFixed.slice(1) : amountToFixed).split('.');

  // Lägg till tusentalsavgränsare till den hela delen och hantera eventuell omtilldelning
  const formattedIntegerPart = (isNegative ? '-' : '') + integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  if (compact && Math.abs(amount) >= 10_000) {
    const isSEK = currency === CurrencyEnum.SEK;
    const abs = Math.abs(amount);

    let value = amount;
    let unit: string;

    if (abs >= 1_000_000) {
      value = amount / 1_000_000;
      unit = isSEK ? 'mkr' : `M ${currency}`;
    } else {
      value = amount / 1_000;
      unit = isSEK ? 'tkr' : `k ${currency}`;
    }

    // formattera enligt compactDecimals, t.ex. 1,25 mkr
    const valueStr = Number.isFinite(value) ? value.toFixed(compactDecimals ?? 1) : '0';
    const [intPartRaw, decPart = ''] = valueStr.split('.');
    const intPart = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const numberOut = decPart ? `${intPart},${decPart}` : intPart;

    return (
      <>
        {numberOut}{' '}
        {showCurrencyInSecondaryStyle ? (
          <Typography sx={{ display: 'inline' }} color='text.secondary' variant={currencyVariant} component='span'>
            {unit}
          </Typography>
        ) : (
          unit
        )}
      </>
    );
  }
  // Återskapa talet med komma som decimalavgränsare och lägg till ' kr' på slutet
  return (
    <>
      {formattedIntegerPart},{decimalPart || '00'}{' '}
      {showCurrencyInSecondaryStyle ? (
        <Typography sx={{ display: 'inline' }} color='textSecondary' variant={currencyVariant} component='span'>
          {currency}
        </Typography>
      ) : (
        currency
      )}
    </>
  );
};
